import React, { useState, useEffect } from "react";
import { Menu, X, Stethoscope } from "lucide-react";
import { Button } from "../ui/button";

const NAV = [
  { label: "About", href: "#about" },
  { label: "Journey", href: "#journey" },
  { label: "Books", href: "#books" },
  { label: "Awards", href: "#awards" },
  { label: "Honors", href: "#honors" },
  { label: "Sports", href: "#sports" },
  { label: "Service", href: "#service" },
  { label: "Gallery", href: "#gallery" },
  { label: "Blog", href: "#blog" },
  { label: "Events", href: "#events" },
  { label: "Contact", href: "#contact" }
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? "bg-ivory/95 backdrop-blur shadow-sm" : "bg-transparent"}`}>
      <div className="kerala-border" />
      <div className="max-w-7xl mx-auto px-5 lg:px-8 flex items-center justify-between h-[72px]">
        <a href="#top" className="flex items-center gap-3 group">
          <div className="w-10 h-10 rounded-full bg-emerald-deep flex items-center justify-center shadow-md">
            <Stethoscope className="w-5 h-5 text-gold" />
          </div>
          <div className="leading-tight">
            <div className="font-display text-emerald-deep text-lg font-semibold">Dr. Shaji Prabhakaran</div>
            <div className="text-[11px] tracking-[0.2em] uppercase text-gold">Neurologist · Author</div>
          </div>
        </a>

        <nav className="hidden lg:flex items-center gap-7">
          {NAV.map(n => (
            <a key={n.href} href={n.href} className="text-sm text-stone-700 hover:text-emerald-deep transition-colors relative group">
              {n.label}
              <span className="absolute left-0 -bottom-1 h-0.5 w-0 bg-gold group-hover:w-full transition-all duration-300" />
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a href="/admin" className="hidden sm:inline-flex">
            <Button variant="outline" className="border-emerald-deep text-emerald-deep hover:bg-emerald-deep hover:text-white">Admin</Button>
          </a>
          <button className="lg:hidden p-2 text-emerald-deep" onClick={() => setOpen(!open)} aria-label="Menu">
            {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden bg-ivory border-t border-stone-200">
          <div className="px-5 py-4 flex flex-col gap-3">
            {NAV.map(n => (
              <a key={n.href} href={n.href} onClick={() => setOpen(false)} className="text-stone-700 py-2 border-b border-stone-100">{n.label}</a>
            ))}
            <a href="/admin" className="text-emerald-deep font-medium py-2">Admin Panel</a>
          </div>
        </div>
      )}
    </header>
  );
}
